export default {
  BASE_SERVER_URI: "https://aiscore.gsport.day/api",
};

// http://127.0.0.1:8000
// http://107.151.150.20:5054

// https://backend.77577.me
